import React from "react";
import Promodata from "./form/Promodata";

export default function AdminPromodata () {

    return(
        <Promodata />
    )
}